export default "__VITE_ASSET__CabOoPfn__"